export default __webpack_public_path__ + "static/media/exclamation-mark.dddf4312.svg";